/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebinvalid2Inputs */

const en_placewebinvalid2 = /** @type {(inputs: Placewebinvalid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That does not look like a website address.`)
};

const de_placewebinvalid2 = /** @type {(inputs: Placewebinvalid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das sieht nicht nach einer Website-Adresse aus.`)
};

/**
* | output |
* | --- |
* | "That does not look like a website address." |
*
* @param {Placewebinvalid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebinvalid2 = /** @type {((inputs?: Placewebinvalid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebinvalid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebinvalid2(inputs)
	return de_placewebinvalid2(inputs)
});
export { placewebinvalid2 as "placeWebInvalid" }